module.exports = __webpack_public_path__ + "media/images/emblems/Corminboeuf-coat_of_arms-db63c58077ab0ce05a51df75797b3a27.svg";